import request from '../utils/request';

export function getMercoTrays(params, signal) {
  return request({
    url: '/dictionaries/merco-trays',
    method: 'get',
    data: params,
    signal,
  });
}

export function getMercoTray(uuid) {
  return request({
    url: `/dictionaries/merco-trays/${uuid}`,
    method: 'get',
  });
}

export function createMercoTray(params) {
  return request({
    url: '/dictionaries/merco-trays',
    method: 'post',
    data: params,
  });
}

export function updateMercoTray(uuid, params) {
  return request({
    url: `/dictionaries/merco-trays/${uuid}`,
    method: 'put',
    data: params,
  });
}

export function deleteMercoTray(uuid) {
  return request({
    url: `/dictionaries/merco-trays/${uuid}`,
    method: 'delete',
    data: uuid,
  });
}
